import { strings } from 'constants/index';
import { IAudienceAggregate } from 'types/api/audience';
import { StatBoxData } from 'types/components';

export const transformAggregate = (aggregate: IAudienceAggregate | null) => {
  const { averageDonation = 0, newDonor = 0, repeatDonor = 0, totalCount = 0 } = aggregate ?? {};

  return [
    {
      count: totalCount,
      title: strings.Site.Count,
    },
    {
      count: averageDonation,
      description: strings.Site.CountWidgetDescription,
      title: strings.Site.AvgDonation,
      type: 'money',
    },
    {
      count: newDonor,
      description: strings.Site.CountWidgetDescription,
      title: strings.Site.SingleGiving,
    },
    {
      count: repeatDonor,
      description: strings.Site.CountWidgetDescription,
      title: strings.Site.MultipleGiving,
    },
  ] as StatBoxData[];
};
